import dJSON from 'dirty-json';

const moduleSelector = '.locations-map';

const locIcon = (cls) => /* html */ `
  <svg class="${cls}" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7656 11.7656C12.2552 11.276 12.5 10.6875 12.5 10C12.5 9.3125 12.2552 8.72396 11.7656 8.23438C11.276 7.74479 10.6875 7.5 10 7.5C9.3125 7.5 8.72396 7.74479 8.23438 8.23438C7.74479 8.72396 7.5 9.3125 7.5 10C7.5 10.6875 7.74479 11.276 8.23438 11.7656C8.72396 12.2552 9.3125 12.5 10 12.5C10.6875 12.5 11.276 12.2552 11.7656 11.7656ZM10 25C6.64583 22.1458 4.14062 19.4948 2.48438 17.0469C0.828125 14.599 0 12.3333 0 10.25C0 7.125 1.00521 4.63542 3.01562 2.78125C5.02604 0.927083 7.35417 0 10 0C12.6458 0 14.974 0.927083 16.9844 2.78125C18.9948 4.63542 20 7.125 20 10.25C20 12.3333 19.1719 14.599 17.5156 17.0469C15.8594 19.4948 13.3542 22.1458 10 25Z" fill="currentColor"/>
  </svg>`;

function activate(root, index) {
  root.querySelector(`.locations-map__box[data-loc="${index}"]`)
    ?.classList.add('locations-map__box--active');
  root.querySelector(`.locations-map__pin[data-loc="${index}"]`)
    ?.classList.add('locations-map__pin--active');
}

function deactivate(root, index) {
  root.querySelector(`.locations-map__box[data-loc="${index}"]`)
    ?.classList.remove('locations-map__box--active');
  root.querySelector(`.locations-map__pin[data-loc="${index}"]`)
    ?.classList.remove('locations-map__pin--active');
}

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((root) => {
    try {
      root.querySelector('script')?.remove();

      const { data } = dJSON.parse(root.data);
      if (!Array.isArray(data) || !data.length) return;

      const grid = root.querySelector('.locations-map__grid');
      const map = root.querySelector('.locations-map__map');
      if (!grid) return;

      data.forEach((item, index) => {
        const phoneHref = item.phone
          ? `tel:${item.phone.replace(/[^+\d]/g, '')}`
          : '';

        grid.insertAdjacentHTML('beforeend', /* html */ `
          <div class="locations-map__box" data-loc="${index}">
            ${locIcon('locations-map__box-icon')}
            <div class="locations-map__box-text">
              <p class="locations-map__name">${item.name || ''}</p>
              ${item.phone ? `<a href="${phoneHref}" class="locations-map__phone">P: ${item.phone}</a>` : ''}
              ${item.email ? `<a href="mailto:${item.email}" class="locations-map__email">${item.email}</a>` : ''}
            </div>
          </div>
        `);

        if (map && item.pin_x && item.pin_y) {
          map.insertAdjacentHTML('beforeend', /* html */ `
            <div class="locations-map__pin" data-loc="${index}"
                 style="left:${item.pin_x}px;top:${item.pin_y}px">
              ${locIcon('locations-map__pin-icon')}
            </div>
          `);
        }
      });

      grid.querySelectorAll('.locations-map__box').forEach((box) => {
        const idx = box.dataset.loc;
        box.addEventListener('mouseenter', () => activate(root, idx));
        box.addEventListener('mouseleave', () => deactivate(root, idx));
      });

      if (map) {
        map.querySelectorAll('.locations-map__pin').forEach((pin) => {
          const idx = pin.dataset.loc;
          pin.addEventListener('mouseenter', () => activate(root, idx));
          pin.addEventListener('mouseleave', () => deactivate(root, idx));
        });
      }
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
